import script from "./ExclusiveRecipe.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusiveRecipe.vue?vue&type=script&setup=true&lang=js"

import "./ExclusiveRecipe.vue?vue&type=style&index=0&id=1ac4de7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac4de7b"]])

export default __exports__